import type { Exchange, OperationContext } from "@urql/vue";
import { mergeMap, pipe, fromValue, map } from "wonka";

type ChangeContextFn =
  | ((ctx: OperationContext) => OperationContext)
  | ((ctx: OperationContext) => OperationContext);

export const contextExchange =
  (fn: ChangeContextFn): Exchange =>
  ({ forward }) => {
    return operations$ =>
      pipe(
        operations$,
        mergeMap(op => {
          const res = fn(op.context);

          return pipe(
            fromValue(res),
            map(ctx => ({ ...op, context: ctx }))
          );
        }),
        forward
      );
  };
